import {
  Collapse,
  Grid,
  TextField,
  Typography,
  Button,
  ThemeProvider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Badge,
} from "@mui/material";
import React, { useMemo } from "react";
import palette from "../../../../../../config/colorPalette";
import { clone, isNil } from "ramda";
import { ErrorText } from "../styled";
import ThresholdsValues from "../../ThresholdsValues";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { handleChannels, maxHandler, minHandler } from "../utils";
import { getMuiTheme } from "../../../../../utils/utils";

const MeasurementInfo = ({
  e,
  equipment,
  measureToggle,
  indexEquipment,
  thresholdsValues,
  setThresholdsValues,
  thresholdsRanges,
  setThresholdsRanges,
  thresholdType,
  channelToggle,
  setChannelToggle,
  substructureDataToggle,
  setSubstructureDataToggle,
  zones,
  setZones,
  zoneToggle,
  setZoneToggle,
  polylineDisplay,
  configData,
  moreSubsAllowed,
  assetData,
  assetMeasurands,
  assetModules,
  assetAdditionalSensors,
  assetExternalServices,
  equipmentTypes,
  errors,
  setErrors,
  intl,
}) => {
  const theme = useMemo(() => getMuiTheme(), []);

  return (
    <Collapse in={measureToggle[indexEquipment]}>
      <section
        style={{
          position: "relative",
          width: "100%",
          borderRadius: "4px",
          border: `1px solid ${palette.primary}`,
          margin: "1.5rem 0",
        }}
      >
        <div style={{ padding: "1rem" }}>
          <Grid>
            {e.channels.map((channel, channelIndex) => (
              <>
                <h1
                  style={{ margin: "2%" }}
                  onClick={() => {
                    let newChannelToggle = clone(channelToggle);
                    if (newChannelToggle[indexEquipment][channelIndex]) {
                      newChannelToggle[indexEquipment][channelIndex] = false;
                    } else {
                      newChannelToggle[indexEquipment][channelIndex] = true;
                    }
                    setChannelToggle(newChannelToggle);
                  }}
                >
                  {channel.name.length > 0 ? `${channel.name} - ` : ""}
                  {intl.formatMessage({ id: "channel.mayus" })} {channelIndex + 1}
                  {!channelToggle[indexEquipment][channelIndex] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                </h1>
                <Collapse in={channelToggle[indexEquipment][channelIndex]}>
                  {channel.substructures.map((sub, indexSub) => {
                    return (
                      <div style={{ marginLeft: "2%" }}>
                        <h2
                          style={{ marginBottom: "2%" }}
                          onClick={() => {
                            let newSubDataToggle = clone(substructureDataToggle);
                            if (newSubDataToggle[indexEquipment][channelIndex][indexSub]) {
                              newSubDataToggle[indexEquipment][channelIndex][indexSub] = false;
                            } else {
                              newSubDataToggle[indexEquipment][channelIndex][indexSub] = true;
                            }
                            setSubstructureDataToggle(newSubDataToggle);
                          }}
                        >
                          {sub.name.length > 0 ? `${sub.name} - ` : ""}
                          {intl.formatMessage({ id: "sub" })} {indexSub + 1}{" "}
                          {!substructureDataToggle[indexEquipment][channelIndex][indexSub] ? (
                            <ArrowDropDownIcon />
                          ) : (
                            <ArrowDropUpIcon />
                          )}
                        </h2>
                        <Collapse in={substructureDataToggle[indexEquipment][channelIndex][indexSub]}>
                          <TextField
                            id={"equipment" + indexEquipment + "_zones" + equipment}
                            style={{ margin: "0 0.2rem 0.8rem" }}
                            defaultValue={
                              zones[`equipment${indexEquipment + 1}`][`channel${channelIndex + 1}`][
                                `sub${indexSub + 1}`
                              ].length
                            }
                            inputProps={{ min: 1 }}
                            onChange={(e) => {
                              handleChannels({
                                e,
                                channelIndex,
                                errors,
                                indexEquipment,
                                indexSub,
                                setErrors,
                                setZones,
                                zones,
                                zoneToggle,
                                setZoneToggle,
                                polylineDisplay,
                                equipment: equipment[indexEquipment],
                              });
                            }}
                            type="number"
                            error={errors["equipment" + indexEquipment + "_zones" + equipment] ? true : false}
                            variant="outlined"
                            label={intl.formatMessage({ id: "measure.zones" })}
                            required
                          ></TextField>
                          {moreSubsAllowed ? <></> : <></>}
                          <Grid
                            container
                            spacing={1}
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                          >
                            {zones[`equipment${indexEquipment + 1}`][`channel${channelIndex + 1}`][
                              `sub${indexSub + 1}`
                            ].map((zone, zoneIndex) => (
                              <Grid item>
                                {!isNil(
                                  errors[`equipment${indexEquipment + 1}]_${channelIndex}_${indexSub}_${zoneIndex}_0`],
                                ) ||
                                !isNil(
                                  errors[`equipment${indexEquipment + 1}]_${channelIndex}_${indexSub}_${zoneIndex}_1`],
                                ) ? (
                                  <Badge
                                    sx={{
                                      "& .MuiBadge-badge": {
                                        backgroundColor: "red",
                                        color: "red",
                                        top: 10,
                                        right: 2,
                                      },
                                    }}
                                    badgeContent=" "
                                  >
                                    <Button
                                      variant="contained"
                                      style={{
                                        margin: "0.5rem 0 0 0.5rem",
                                        backgroundColor: palette.secondary,
                                        color: "white",
                                      }}
                                      id={`channel${channelIndex}_collapse${indexSub}_${zoneIndex}`}
                                      onClick={() => {
                                        let newZoneToggle = clone(zoneToggle);
                                        if (newZoneToggle[indexEquipment][channelIndex][indexSub][zoneIndex]) {
                                          newZoneToggle[indexEquipment][channelIndex][indexSub][zoneIndex] = false;
                                        } else {
                                          newZoneToggle[indexEquipment][channelIndex][indexSub][zoneIndex] = true;
                                        }
                                        setZoneToggle(newZoneToggle);
                                      }}
                                    >
                                      {intl.formatMessage({ id: "zone.mayus" })} {zoneIndex + 1}
                                    </Button>
                                  </Badge>
                                ) : (
                                  <Button
                                    variant="contained"
                                    style={{
                                      margin: "0.5rem 0 0 0.5rem",
                                      backgroundColor: palette.secondary,
                                      color: "white",
                                    }}
                                    id={`channel${channelIndex}_collapse${indexSub}_${zoneIndex}`}
                                    onClick={() => {
                                      let newZoneToggle = clone(zoneToggle);
                                      if (newZoneToggle[indexEquipment][channelIndex][indexSub][zoneIndex]) {
                                        newZoneToggle[indexEquipment][channelIndex][indexSub][zoneIndex] = false;
                                      } else {
                                        newZoneToggle[indexEquipment][channelIndex][indexSub][zoneIndex] = true;
                                      }
                                      setZoneToggle(newZoneToggle);
                                    }}
                                  >
                                    {intl.formatMessage({ id: "zone.mayus" })} {zoneIndex + 1}
                                  </Button>
                                )}

                                <ThemeProvider theme={theme}>
                                  <Dialog
                                    maxWidth="md"
                                    open={zoneToggle[indexEquipment][channelIndex][indexSub][zoneIndex]}
                                    onClose={() => {
                                      let newZoneToggle = clone(zoneToggle);
                                      newZoneToggle[indexEquipment][channelIndex][indexSub][zoneIndex] = false;
                                      setZoneToggle(newZoneToggle);
                                    }}
                                  >
                                    <DialogTitle>
                                      {intl.formatMessage({ id: "zone.mayus" })} {zoneIndex + 1}
                                    </DialogTitle>
                                    <DialogContent>
                                      <Grid
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        sx={{ marginTop: "2%" }}
                                      >
                                        <Grid item xs={3}>
                                          <TextField
                                            inputProps={{ min: 0, step: "0.1" }}
                                            label={intl.formatMessage({ id: "range.min" })}
                                            type="number"
                                            variant="outlined"
                                            fullWidth
                                            key={`equipment${
                                              indexEquipment + 1
                                            }]_${channelIndex}_${indexSub}_${zoneIndex}_0`}
                                            error={
                                              errors[
                                                `equipment${
                                                  indexEquipment + 1
                                                }]_${channelIndex}_${indexSub}_${zoneIndex}_0`
                                              ]
                                                ? true
                                                : false
                                            }
                                            defaultValue={zone.ini}
                                            onChange={(e) => {
                                              minHandler({
                                                e,
                                                zones,
                                                setZones,
                                                indexEquipment,
                                                channelIndex,
                                                indexSub,

                                                zoneIndex,
                                                errors,
                                                setErrors,
                                              });
                                            }}
                                          />
                                          {!isNil(
                                            errors[
                                              `equipment${
                                                indexEquipment + 1
                                              }]_${channelIndex}_${indexSub}_${zoneIndex}_0`
                                            ],
                                          ) && (
                                            <ErrorText style={{ margin: "0.2rem" }}>
                                              {intl.formatMessage({
                                                id: errors[
                                                  `equipment${
                                                    indexEquipment + 1
                                                  }]_${channelIndex}_${indexSub}_${zoneIndex}_0`
                                                ],
                                              })}
                                            </ErrorText>
                                          )}
                                        </Grid>
                                        <Grid item xs={1} style={{ textAlign: "center" }}>
                                          <Typography variant="h6">-</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                          <TextField
                                            inputProps={{ min: 0, step: "0.1" }}
                                            key={`equipment${
                                              indexEquipment + 1
                                            }]_${channelIndex}_${indexSub}_${zoneIndex}_1`}
                                            label={intl.formatMessage({ id: "range.max" })}
                                            type="number"
                                            variant="outlined"
                                            fullWidth
                                            defaultValue={zone.end}
                                            value={zone.end}
                                            error={
                                              errors[
                                                `equipment${
                                                  indexEquipment + 1
                                                }]_${channelIndex}_${indexSub}_${zoneIndex}_1`
                                              ]
                                                ? true
                                                : false
                                            }
                                            onChange={(e) => {
                                              maxHandler({
                                                e,
                                                indexEquipment,
                                                channelIndex,
                                                zoneIndex,
                                                indexSub,
                                                polylineDisplay,
                                                equipment: equipment[indexEquipment],
                                                errors,
                                                setErrors,
                                                setZones,
                                                zones,
                                              });
                                            }}
                                          />
                                          {!isNil(
                                            errors[
                                              `equipment${
                                                indexEquipment + 1
                                              }]_${channelIndex}_${indexSub}_${zoneIndex}_1`
                                            ],
                                          ) && (
                                            <ErrorText style={{ margin: "0.2rem" }}>
                                              {intl.formatMessage({
                                                id: errors[
                                                  `equipment${
                                                    indexEquipment + 1
                                                  }]_${channelIndex}_${indexSub}_${zoneIndex}_1`
                                                ],
                                              })}
                                            </ErrorText>
                                          )}
                                        </Grid>
                                      </Grid>
                                      <ThresholdsValues
                                        key={`equipment${indexEquipment}_${channelIndex}_${zoneIndex}`}
                                        thresholdTypes={thresholdType?.[0]}
                                        errors={errors}
                                        setErrors={setErrors}
                                        equipment={`equipment${indexEquipment + 1}`}
                                        thresholdsValues={thresholdsValues}
                                        setThresholdsValues={setThresholdsValues}
                                        thresholdsRanges={thresholdsRanges}
                                        setThresholdsRanges={setThresholdsRanges}
                                        equipmentIndex={indexEquipment}
                                        channelIndex={channelIndex}
                                        setZones={setZones}
                                        zones={zones}
                                        indexSub={indexSub}
                                        zoneIndex={zoneIndex}
                                        configData={configData}
                                        e={e}
                                        assetData={assetData}
                                        assetAdditionalSensors={assetAdditionalSensors}
                                        assetExternalServices={assetExternalServices}
                                        assetMeasurands={assetMeasurands}
                                        assetModules={assetModules}
                                        equipmentTypes={equipmentTypes}
                                      />
                                    </DialogContent>
                                    <DialogActions>
                                      <Button
                                        variant="contained"
                                        style={{ backgroundColor: palette.secondary, color: "white" }}
                                        onClick={() => {
                                          let newZoneToggle = clone(zoneToggle);
                                          newZoneToggle[indexEquipment][channelIndex][indexSub][zoneIndex] = false;
                                          setZoneToggle(newZoneToggle);
                                        }}
                                      >
                                        {intl.formatMessage({ id: "accept" })}
                                      </Button>
                                    </DialogActions>
                                  </Dialog>
                                </ThemeProvider>
                              </Grid>
                            ))}
                          </Grid>
                        </Collapse>
                      </div>
                    );
                  })}
                </Collapse>
              </>
            ))}
          </Grid>
        </div>
      </section>
    </Collapse>
  );
};

export default MeasurementInfo;
